export const add = function (params) {
  return this.$http('post', 'mall/supShopTag/create', params);
}
export const del = function (ids) {
  return this.$http('post', 'mall/supShopTag/deleteAll', ids);
}

export const edit = function (data) {
  return this.$http('post', 'mall/supShopTag/update', data);
}

export const getTagList = function (params) {
  return this.$http('get', 'mall/supShopTag/listByTagType', params);
}


// 渠道标签
export const getChannelTagList = function (params) {
  return this.$http('get', 'mall/bdChannelTagConfig/listAll', params);
}

// 新增渠道标签
export const addChannelTag = function (params) {
  return this.$http('post', 'mall/bdChannelTagConfig/create', params);
}

// editChannelTag 编辑渠道标签
export const editChannelTag = function (params) {
  return this.$http('post', 'mall/bdChannelTagConfig/update', params);
}

// mall/bdChannelTagConfig/deleteAll 删除渠道标签
export const delChannelTag = function (ids) {
  return this.$http('post', 'mall/bdChannelTagConfig/deleteAll', ids);
}

// 批量新增
export const batchAddTag = function (ids) {
  return this.$http('post', 'mall/bdChannelTag/batchAddTag', ids);
}
// 批量删除
export const batchDeleteTag = function (ids) {
  return this.$http('post', 'mall/bdChannelTag/batchDeleteTag', ids);
}
